// src/components/RankingPopup.jsx
import React, { useEffect, useState } from 'react';
import './RankingPopup.css';
import { API_URL } from '../config';

const RankingPopup = ({ visible, onClose }) => {
  const [ranking, setRanking] = useState([]);

  useEffect(() => {
    if (visible) {
      fetch(`${API_URL}/ranking`)
        .then(res => res.json())
        .then(data => setRanking(data))
        .catch(err => console.error('❌ Error cargando ranking:', err));
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-contenido">
        <h3>🏆 Ranking Top 10</h3>
        <ul className="lista-ranking">
          {ranking.map((usuario, i) => (
            <div className="fila-ranking" key={i}>
                <span>{i + 1}. {usuario.NombreUsuario}</span>
                <span>{usuario.Puntaje} pts</span>
            </div>
        ))}
        </ul>
        <button className="btn-cerrar-ranking" onClick={onClose}>✖️ Cerrar</button>
      </div>
    </div>
  );
};

export default RankingPopup;
